import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import { Row, Table, Tooltip, Spin, Drawer, Modal } from 'antd';
import moment from 'moment-timezone';
import ls from 'local-storage';
import _ from 'lodash';
import Sticky from 'react-sticky-el';
import LeadDetailsCard from '../LeadDetailsCard/LeadDetailsCard';
import {
  BuildingIcon,
  BoltIcon,
  LinkIcon,
  EyeIcon,
  EyeFillIcon,
  NetworkCrossedIcon,
  NetworkIcon,
  ThreeDotsIcon,
  HubspotCharcoalIcon,
  HubspotCoralIcon,
  HubspotWhiteIcon,
} from '../../Icons';
import helpers from '../../../utils/helpers';
import { AjaxTable, ExportFile, LeadsVisitsFilter } from '../../../components';
import styles from '../styles.less';
import ScoringCircle from '../../common/ScoringCircle';
import MultiplyItemsColumnRender from '../../common/Table/MultiplyItemsColumnRender';
import { defaultTableConfig } from '../../../utils/dataTable';
import CountryColumnRenderer from '../../common/Table/CountryColumnRenderer';
import DateTimeColumnRenderer from '../../common/Table/DateTimeColumnRenderer';
import { SearchCreateCompanyModal, ViewHubspotTransfer } from '../index';
import { WithMarkIspPermissions, WithHubspotProjectPermissions, WithHideCompanyPermissions } from '../../Permissions';
import CreateHubspotTransferModal from '../Hubspot/CreateHubspotTransferModal';

const LS_VISITS_FILTERS = 'LXP_LEAD_VISITS_TABLE_FILTERS';

class LeadsVisitsOverview extends React.Component {
  constructor(props) {
    super(props);
    this.defaultFiltersState = {
      companyVisibility: 'VISIBLE',
      dateRange: [
        moment().subtract(30, 'day'),
        moment(),
      ],
    };

    this.state = {
      tableKeepPage: false,
      projectId: this.props.currentProjectId || Number(this.props.match.params.projectId),
      period: [],
      sorting: defaultTableConfig.sorting,
      showKompassBranches: false,
      classificationCodes: [],
      filters: Object.assign({}, this.defaultFiltersState, ls.get(LS_VISITS_FILTERS)),
      companyDetailsDrawerVisible: false,
      searchCreateCompanyModalVisible: false,
      createHubspotTransferModalVisible: false,
      viewHubspotTransferDrawerVisible: false,
      replaceTableRecords: [],
      viewHubspotTransfer: null,
      transferToHubspot: {
        hasHubspotTransferClaim: null,
        companyId: null,
        companyName: null,
        hubspotCompanyId: null,
        visitId: null,
        tableRecord: null,
      },
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Leads.VisitsList.Title',
        description: 'Component.Leads.VisitsList.Description1',
      },
    });

    this.props.dispatch({ type: 'app/showNotifications' });

    this.getClassificationCodes();
  }

  componentDidUpdate() {
    const toLocalStorage = Object.assign({}, this.state.filters);
    delete toLocalStorage.dateRange;
    ls.set(LS_VISITS_FILTERS, toLocalStorage);
  }

  onQuickView = (projectId, leadId) => {
    this.setState({ projectId, leadId });

    this.props.dispatch({
      type: 'leads/getDetails',
      payload: {
        projectId,
        leadId,
      },
    }).then((leadDetails) => {
      this.props.dispatch({
        type: 'matomo/updateStore',
        payload: { leadDetails },
      });

      return this.props.dispatch({ type: 'leadLabels/loadList',
        payload: {
          filter: { client_id: this.props.selectedClient.id },
        } });
    }).then(({ data }) => this.props.dispatch({
      type: 'leadLabels/updateStore',
      payload: { allLeadMarks: data },
    }));

    this.toggleCompanyDetailsDrawer();
  }

  onTransferToHubspot = (record) => {
    // we already have a mapping, but task not created yet, queue working on it
    if (record.has_hubspot_transfer_claim === true && record.company.hs_company_id) {
      return Modal.info({
        content: this.props.intl.formatMessage({ id: 'Component.SearchCreateCompanyModal.Info.PendingTaskCreatingInProgress' }),
      });
    }

    this.setState({
      viewHubspotTransfer: null,
      searchCreateCompanyModalVisible: !record.company.hs_company_id,
      createHubspotTransferModalVisible: !!record.company.hs_company_id,
      transferToHubspot: {
        hasHubspotTransferClaim: record.has_hubspot_transfer_claim,
        companyId: record.company.id,
        companyName: record.company.company_name,
        companyDomain: record.company.domain,
        visitId: record.id,
        tableRecord: record,
        hubspotCompanyId: record.company.hs_company_id,
      },
    });
  }

  onTransferredToHubSpot = (record) => {
    this.setState({
      viewHubspotTransferDrawerVisible: true,
      viewHubspotTransfer: {
        hubspot_transfer_id: this.props.currentProject.hubspot_create_tasks ?
          record.hubspot_transfer_id :
          record.company.hubspot_transfer_id_recent,
      },
    });
  }

  onTaskCreateCancel = () => {
    this.setState({
      searchCreateCompanyModalVisible: false,
    });
  }

  onTaskCreated = (hubspotTransfer) => {
    const record = {
      ...this.state.transferToHubspot.tableRecord,
      hubspot_transfer_id: hubspotTransfer.id,
      company: {
        ...this.state.transferToHubspot.tableRecord.company,
        hs_deal_id: hubspotTransfer.hs_deal_id,
      },
    };

    this.setState({
      transferToHubspot: {},
      createHubspotTransferModalVisible: false,
      replaceTableRecords: [record],
      viewHubspotTransferDrawerVisible: true,
      viewHubspotTransfer: {
        hubspot_transfer_id: record.hubspot_transfer_id,
      },
    });
  }

  getClassificationCodes(id = '[null]') {
    this.props.dispatch({
      type: 'branches/getKompassBranchesList',
      payload: { id },
    }).then(resp => this.setState({ classificationCodes: resp.data }));
  }

  getData(psf) {
    const { filters } = this.state;
    const projectId = this.props.currentProjectId || this.state.projectId;
    this.setState({
      sorting: psf.sorting,
    });

    return this.props.dispatch({
      type: 'leads/loadProjectVisits',
      payload: {
        ...psf,
        projectId,
        filter: this.filtersToQueryFilter(filters),
      },
    });
  }

  hideCreateHubspotTransferModal = () => {
    this.setState({
      viewHubspotTransferDrawerVisible: false,
      createHubspotTransferModalVisible: false,
      transferToHubspot: {},
    });
  }

  hideViewHubspotTransferDrawer = () => {
    this.setState({
      createHubspotTransferModalVisible: false,
      viewHubspotTransferDrawerVisible: false,
      viewHubspotTransfer: null,
    });
  }

  matchCompanyToCreatePendingTask = async (hsCompanyId, lxpCompanyId) => {
    if (hsCompanyId) {
      await this.props.dispatch({
        type: 'hubspot/linkHubspotCompany',
        payload: {
          projectId: this.state.projectId,
          lxpCompanyId,
          hsCompanyId,
        },
      });
    } else {
      await this.props.dispatch({
        type: 'hubspot/createHubspotCompany',
        payload: {
          projectId: this.state.projectId,
          lxpCompanyId,
        },
      });
    }

    this.setState({
      searchCreateCompanyModalVisible: false,
      createHubspotTransferModalVisible: false,
      transferToHubspot: {},
      viewHubspotTransferDrawerVisible: true,
      viewHubspotTransfer: null,
      updateTimestamp: Date.now(),
    });
  }

  showCreateTaskPanel = (hubspotCompanyId, lxpCompanyId) => {
    this.setState({
      searchCreateCompanyModalVisible: false,
      createHubspotTransferModalVisible: true,
      transferToHubspot: {
        ...this.state.transferToHubspot,
        hubspotCompanyId,
        companyId: lxpCompanyId,
      },
    });
  }

  toggleCompanyDetailsDrawer = () => {
    this.setState(prevState => ({
      companyDetailsDrawerVisible: !prevState.companyDetailsDrawerVisible,
    }));
  }


  markISP(id, isp) {
    this.props.dispatch({
      type: 'leads/markISP',
      payload: { id, mark: isp },
    }).then(() => {
      this.refreshTableAndKeepPage();
    });
  }

  hideCompanyToggle = (id, hide) => {
    this.props.dispatch({
      type: 'leads/setHidden',
      payload: { companyId: id, hidden: hide, projectId: this.state.projectId },
    }).then(() => {
      this.refreshTableAndKeepPage();
    });
  }

  refreshTableAndKeepPage() {
    this.setState({
      updateTimestamp: Date.now(),
      tableKeepPage: true,
    });
  }

  updateFiltersState = (filters) => {
    this.setState({ filters });
  }

  filtersToQueryFilter = (filters) => {
    const {
      companyName,
      dateRange,
      leadMarks,
      score,
      countries,
      city,
      source,
      campaign,
      campaignName,
      customerNumber,
      branches,
      scoringProfiles,
      scoringProfilesVisibility,
      companyVisibility,
      hubspotTask,
    } = filters;

    const filterParams = {};

    switch (hubspotTask) {
      case 'HAS_HUBSPOT_TRANSFER':
        filterParams['hubspot_transfer_id!'] = '[null]';
        break;
      case 'NO_HUBSPOT_TRANSFER':
        filterParams.hubspot_transfer_id = '[null]';
        break;
      case 'PENDING':
        filterParams.has_hubspot_transfer_claim = '1';
        break;
      case 'ALL':
      default:
        break;
    }

    switch (companyVisibility) {
      case 'HIDDEN':
        filterParams['company.is_hidden'] = 1;
        break;
      case 'ALL':
        // no filters...
        break;
      case 'FILTERED':
        filterParams['company.is_isp'] = 1;
        break;
      case 'VISIBLE':
      default:
        filterParams['company.is_isp'] = 0;
        filterParams['company.is_hidden'] = 0;
    }

    if (scoringProfilesVisibility && scoringProfilesVisibility !== 'ALL') {
      const scoreKey = scoringProfilesVisibility === 'PRIVATE' ? 'private_score' : 'score';
      filterParams[`${scoreKey}>=0`] = null;
    }

    if (companyName && companyName.trim()) {
      filterParams['company.company_name'] = `*${companyName.trim()}*`;
    }

    if (campaign && campaign.trim().length > 0) {
      filterParams.referrer_keyword = `*${campaign.trim()}*`;
    }

    if (campaignName && campaignName.trim().length > 0) {
      filterParams.campaign_name = `*${campaignName.trim()}*`;
    }

    if (countries) {
      filterParams['company.country'] = countries;
    }

    if (city && city.trim().length > 0) {
      filterParams['company.city'] = `*${city.trim()}*`;
    }

    if (customerNumber) {
      filterParams['company.customer_number'] = customerNumber;
    }

    if (scoringProfiles && scoringProfiles.length > 0) {
      filterParams['final_scoring_profile.id'] = scoringProfiles;
    }

    // score filter present and not equal to show all
    if (score && score !== 'ALL') {
      if (score === '[null]') {
        filterParams.final_score = score;
      } else {
        filterParams[`final_score>=${score}`] = null;
      }
    }

    let from;
    let to;
    if (dateRange && dateRange.length > 0) {
      const [visitStartFrom, visitStartTo] = dateRange;

      from = moment.tz(visitStartFrom.set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      }), this.props.timezone || 'utc');
      to = moment.tz(visitStartTo.set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 59,
      }), this.props.timezone || 'utc');

      filterParams[`first_action_timestamp>=${from.toISOString()}`] = null;
      filterParams[`first_action_timestamp<=${to.toISOString()}`] = null;
    }

    if (leadMarks && leadMarks.length > 0) {
      filterParams['company.leadMarks'] = leadMarks;
    }

    if (source && source.length > 0) {
      filterParams.referrer_type = source;
    }

    if (branches && branches.length > 0) {
      const codesPropName = this.props.useCustomBranches ?
        'company.classificationCodes.branches' :
        'company.classificationCodes';

      filterParams[codesPropName] = branches.map(i => i.key);
    }

    return filterParams;
  }

  isDefaultFilters = () => {
    const filters = Object.assign({}, this.state.filters);
    delete filters.dateRange;
    const defaultFilters = Object.assign({}, this.defaultFiltersState);
    delete defaultFilters.dateRange;
    return _.isEqual(filters, defaultFilters);
  }

  resetFilters = () => {
    this.updateFiltersState(this.defaultFiltersState);
  }

  canHubspotTransferBeCreated = (record) => {
    const createTasks = this.props.currentProject.hubspot_create_tasks;
    const createDeals = this.props.currentProject.hubspot_create_deals;

    if (createTasks) {
      return !record.hubspot_transfer_id;
    }

    if (createDeals) {
      return !record.company.hs_deal_id;
    }
  }

  render() {
    const { Column } = Table;
    const projectId = this.props.currentProjectId;
    const { companyDetailsDrawerVisible } = this.state;
    const { useCustomBranches } = this.props;
    const showCustomBranches = useCustomBranches && !this.state.showKompassBranches;
    const branchesTitleId = useCustomBranches ? 'Grid.Column.Branches' : 'Grid.Column.ClassificationCodes';
    const showClearFilters = this.isDefaultFilters() === false;

    return (
      <div className={styles.containerLarge}>
        <SearchCreateCompanyModal
          isLoading={!!this.props.loading.effects['hubspot/linkHubspotCompany'] || !!this.props.loading.effects['hubspot/createHubspotCompany']}
          description1={
            this.state.transferToHubspot.hasHubspotTransferClaim ?
              'Component.SearchCreateCompanyModal.Description1PendingTask' :
              'Component.SearchCreateCompanyModal.Description1'
          }
          onCancel={this.onTaskCreateCancel}
          visible={this.state.searchCreateCompanyModalVisible}
          companyId={this.state.transferToHubspot.companyId}
          companyName={this.state.transferToHubspot.companyName}
          onCompanySelected={
            this.state.transferToHubspot.hasHubspotTransferClaim ?
              this.matchCompanyToCreatePendingTask :
              this.showCreateTaskPanel
          }
        />
        <div>
          <Sticky
            className="sticky-bar"
            scrollElement=".ant-layout"
            stickyClassName="_sticky"
          >
            <div className="sticky-wrapper">
              <Row className="filtersWrap" type="flex" align="top" justify="space-between">
                <LeadsVisitsFilter
                  dateFormat={this.props.currentUser.display_datetime_format && this.props.currentUser.display_datetime_format.split(' ')[0]}
                  onChange={this.updateFiltersState}
                  showKompassBranches={show => this.setState({ showKompassBranches: show })}
                  customBranches={this.props.useCustomBranches}
                  timezone={this.props.currentUser.display_timezone}
                  projectId={this.state.projectId}
                  selectedClientId={this.props.selectedClient.id}
                  formFields={this.state.filters}
                  resetFilters={this.resetFilters}
                  showClearFilters={showClearFilters}
                />
                <ExportFile
                  filter={this.filtersToQueryFilter(this.state.filters)}
                  period={this.state.period}
                  sorting={this.state.sorting}
                  data="visits"
                />
              </Row>
            </div>
          </Sticky>
          <AjaxTable
            keepPage={this.state.tableKeepPage}
            rowKey="id"
            className={[styles.companyAttributesList, styles.noMarginBottom].join(' ')}
            updateKey={JSON.stringify([
              this.state.filters,
              this.state.updateTimestamp,
              this.props.match.params.projectId,
            ])}
            getData={this.getData.bind(this)}
            defaultParams={{ sorting: this.state.sorting }}
            tableLayout={'fixed'}
            replaceRecords={this.state.replaceTableRecords}
          >
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Score' })}
              dataIndex="final_score"
              key="final_score"
              className="text-center"
              sorter
              width="40px"
              render={(value, record) => (
                <ScoringCircle
                  publicScore={record.score}
                  privateScore={record.private_score}
                  finalScore={record.final_score}
                  scoringProfile={record.scoring_profile}
                  privateScoringProfile={record.private_scoring_profile}
                />
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Country' })}
              dataIndex="company"
              key="country"
              className="text-center"
              render={(company) => {
                return <CountryColumnRenderer country={company.country} />;
              }}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.City' })}
              dataIndex="company"
              key="city"
              className="text-center"
              render={company => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.City' })}
                >
                  {company.city}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.CompanyName' })}
              dataIndex="company"
              key="company"
              className={styles.tableColumnWrap}
              render={item => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.CompanyName' })}
                >
                  {item.company_name}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Component.LeadDetails.Source' })}
              key="referrer_type"
              className="text-center"
              render={(item) => {
                const referrerType = item.referrer_type ? item.referrer_type.label : undefined;
                const data = [referrerType];
                if (item.referrer_keyword) {
                  data.push(`Name: ${item.campaign_name}`);
                  data.push(`Keyword: ${item.referrer_keyword}`);
                }

                return (<MultiplyItemsColumnRender itemList={data.filter(Boolean)} showLeftNumber={false} />);
              }}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.VisitStartTimestamp' })}
              dataIndex="first_action_timestamp"
              key="first_action_timestamp"
              className={styles.whiteColumn}
              sorter
              defaultSortOrder="descend"
              render={(dateTime) => {
                return (
                  <DateTimeColumnRenderer
                    displayTimezone={this.props.currentUser.display_timezone}
                    displayFormat={this.props.currentUser.display_datetime_format}
                    dateTime={dateTime}
                  />
                );
              }}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Duration' })}
              key="time"
              className="text-center"
              dataIndex="visit_duration"
              sorter
              render={item => (
                <div
                  className="text-center"
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Duration' })}
                >
                  {moment.utc(item * 1000).format('HH:mm:ss')}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Component.LeadDetails.Pages' })}
              key="pages"
              className="text-center"
              dataIndex="page_views"
              sorter
              render={item => (
                <div
                  className="text-center"
                  data-label={this.props.intl.formatMessage({ id: 'Component.LeadDetails.Pages' })}
                >
                  {item}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.LeadLabel' })}
              dataIndex="company[lead_marks]"
              key="leadMarks"
              className="text-center"
              render={leadMarks => <MultiplyItemsColumnRender itemList={leadMarks.map(i => (i.name ? i.name : ''))} />}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.CustomerNumber' })}
              dataIndex="company"
              key="customer_number"
              className="text-center"
              render={company => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.CustomerNumber' })}
                >
                  {company.customer_number}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: branchesTitleId })}
              dataIndex="company[classification_codes]"
              key="classificationСodes"
              className="text-center"
              render={(codes) => {
                const data = showCustomBranches ?
                  helpers.getUniqueCustomBranches(codes).map(i => i.name) :
                  codes.map(i => (i.label));

                return (<MultiplyItemsColumnRender itemList={data} />);
              }}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Actions' })}
              key="details"
              className="text-center"
              fixed="right"
              width={220}
              render={record => (
                <div className="actions" data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Actions' })}>
                  <Tooltip
                    className="hint" placement="top"
                    title={this.props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.VisitDetails' })}
                  >
                    <Link
                      className="action-wrap" target="_blank"
                      to={`/${projectId}/companies/${record.company.id}/visits/${record.id}`}
                    >
                      <ThreeDotsIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint" placement="top"
                    title={this.props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.ViewDetails' })}
                  >
                    <Link
                      className="action-wrap" target="_blank"
                      to={`/${projectId}/lead-management/leads/${record.company.id}/details/`}
                    >
                      <BuildingIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint" placement="top"
                    title={this.props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.QuickView' })}
                  >
                    <button className="action-wrap" onClick={() => this.onQuickView(projectId, record.company.id)}>
                      <BoltIcon />
                    </button>
                  </Tooltip>
                  <WithHideCompanyPermissions>
                    <span>
                      <Tooltip
                        className="hint"
                        placement="top"
                        title={this.props.intl.formatMessage({ id: record.company.is_hidden ? 'Component.Leads.VisitsList.Button.Hint.Unhide' : 'Component.Leads.VisitsList.Button.Hint.Hide' })}
                      >
                        <button
                          className="action-wrap"
                          onClick={() => this.hideCompanyToggle(record.company.id, !record.company.is_hidden)}
                        >
                          {record.company.is_hidden ? <EyeFillIcon /> : <EyeIcon />}
                        </button>
                      </Tooltip>
                    </span>
                  </WithHideCompanyPermissions>
                  <WithMarkIspPermissions>
                    <span>
                      <Tooltip
                        className="hint"
                        placement="top"
                        title={this.props.intl.formatMessage({ id: record.company.is_isp ? 'Component.Leads.VisitsList.Button.Hint.MarkAsNotIsp' : 'Component.Leads.VisitsList.Button.Hint.MarkAsIsp' })}
                      >
                        <button
                          className="action-wrap"
                          onClick={() => this.markISP(record.company.id, !record.company.is_isp)}
                        >
                          {record.company.is_isp ? <NetworkCrossedIcon /> : <NetworkIcon />}
                        </button>
                      </Tooltip>
                    </span>
                  </WithMarkIspPermissions>
                  <Tooltip
                    className="hint" placement="top"
                    title={record.company.websites.length ? this.props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.OpenWebiste' }) : null}
                  >
                    <a
                      href={record.company.websites.length ? record.company.websites[0] : null}
                      className={record.company.websites.length ? 'action-wrap' : 'action-wrap disabled'}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LinkIcon />
                    </a>
                  </Tooltip>
                  <WithHubspotProjectPermissions>
                    <Tooltip
                      className="hint" placement="top"
                      title={this.canHubspotTransferBeCreated(record) ? this.props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.TransferToHubspot' }) : ''}
                    >
                      <button
                        style={{
                          backgroundColor: record.has_hubspot_transfer_claim ? 'red' : null,
                          display: (this.props.currentProject.hubspot_create_tasks || this.props.currentProject.hubspot_create_deals) ? 'inherit' : 'none',
                        }}
                        className="action-wrap"
                        onClick={() => (this.canHubspotTransferBeCreated(record) ? this.onTransferToHubspot(record) : this.onTransferredToHubSpot(record))}
                      >
                        {record.has_hubspot_transfer_claim ?
                          <HubspotWhiteIcon /> :
                          this.canHubspotTransferBeCreated(record) ? <HubspotCoralIcon /> : <HubspotCharcoalIcon />}
                      </button>
                    </Tooltip>
                  </WithHubspotProjectPermissions>
                </div>
              )}
            />
          </AjaxTable>
        </div>
        {/* Company Details */}
        {companyDetailsDrawerVisible &&
          <Drawer
            width={400}
            placement="right"
            closable
            onClose={this.toggleCompanyDetailsDrawer}
            visible={companyDetailsDrawerVisible}
          >
            <Spin
              spinning={!!this.props.loading.effects['leads/getDetails']
                || !!this.props.loading.effects['matomo/updateStore']}
            >
              <LeadDetailsCard
                allLeadMarks={this.state.allLeadMarks}
                projectId={this.state.projectId}
                leadId={this.state.leadId}
                brancheTitle={this.props.intl.formatMessage({ id: branchesTitleId })}
                toShow={useCustomBranches && !this.state.showKompassBranches}
                showKompassBranches={this.state.showKompassBranches}
              />
            </Spin>
          </Drawer>
        }
        {/* Create hubspot task */}
        {this.state.createHubspotTransferModalVisible &&
          <CreateHubspotTransferModal
            visible={this.state.createHubspotTransferModalVisible}
            onCancel={this.hideCreateHubspotTransferModal}
            hubspotCompanyId={this.state.transferToHubspot.hubspotCompanyId}
            visitId={this.state.transferToHubspot.visitId}
            lxpCompanyId={this.state.transferToHubspot.companyId}
            companyName={this.state.transferToHubspot.companyName}
            companyDomain={this.state.transferToHubspot.companyDomain}
            onTaskCreated={this.onTaskCreated}
          />
        }
        {/* View hubspot task */}
        {this.state.viewHubspotTransferDrawerVisible && this.state.viewHubspotTransfer &&
          <Drawer
            width={400}
            placement="right"
            closable
            onClose={this.hideViewHubspotTransferDrawer}
            visible={this.state.viewHubspotTransferDrawerVisible}
          >
            <ViewHubspotTransfer
              hubspotTransferId={this.state.viewHubspotTransfer.hubspot_transfer_id}
              onTaskNotFound={this.hideViewHubspotTransferDrawer}
            />
          </Drawer>
        }
      </div>
    );
  }
}

export default connect(({ leadsVisits, hubspot, loading, app }) => ({
  leadsVisits,
  loading,
  hubspot,
  currentProjectId: app.currentProjectId,
  currentUser: app.user,
  useCustomBranches: app.useCustomBranches,
  currentProject: app.currentProject,
  selectedClient: app.selectedClient,
}))(injectIntl(LeadsVisitsOverview));



// WEBPACK FOOTER //
// ./src/components/Leads/LeadsVisitsOverview/LeadsVisitsOverview.js